/* src/app/core/components/feedback-modal/feedback-modal.component.scss */
.form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
textarea.input {
  width: 100%;
  padding: 1rem;
  border-radius: 0.75rem;
  border: 2px solid #ccc;
  resize: vertical;
  min-height: 50dvh;
}
textarea.input:focus-visible {
  outline: none;
  border: 2px solid #1289ad;
}
.button-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.button {
  width: 100%;
  padding: 1rem;
  border-radius: 1000rem;
  background: #4ac8f3;
  color: #fff;
  cursor: pointer;
  font-weight: bold;
  border: 2px solid #4ac8f3;
  transition: all 150ms;
}
.button:focus-visible {
  outline: none;
  border: 2px solid #1289ad;
}
.button:disabled {
  cursor: not-allowed;
  filter: grayscale(0.5);
}
.button.button-secondary {
  background: #fff;
  color: #4ac8f3;
  border: 2px solid #4ac8f3;
}
/*# sourceMappingURL=feedback-modal.component.css.map */
